import * as Sentry from '@sentry/react';
import axiosInstance from '../../core/axiosConfig.ts';

/** A deal as /admin/deals returns it (DealResponse). */
export interface Deal {
    id: number;
    code: string;
    name: string;
    link: string;
    locationId: number;
    restaurantName: string;
    inventoryItemId: number;
    itemName: string;
    menuPrice: number;
    dealPrice: number;
    restaurantShare: number;
    velloShare: number;
    startTime: string;
    endTime: string;
    waiveMinOrder: boolean;
    isActive: boolean;
    notes: string | null;
    claims: number;
    used: number;
    createdAt: string;
}

/** One customer's claim (DealClaimRow). */
export interface DealClaim {
    id: number;
    customerId: number;
    customerName: string | null;
    phoneNumber: string | null;
    claimedAt: string;
    usedAt: string | null;
    orderId: number | null;
    orderNumber: string | null;
}

/** A dish on a restaurant's menu, for the picker (the customer-facing menu, public). */
export interface MenuDish {
    id: number;
    name: string;
    price: string;
}

const report = (source: string) => (e: unknown) => { Sentry.captureException(e, { tags: { source } }); throw e; };

export default class DealService {
    async claims(dealId: number): Promise<DealClaim[]> {
        return axiosInstance.get(`/admin/deals/${dealId}/claims`).then((r) => r.data).catch(report('deal-claims'));
    }

    /** The dishes of one restaurant, from the same menu the apps show. */
    async dishes(locationId: number): Promise<MenuDish[]> {
        const data = await axiosInstance.get('/restaurant/get', { params: { language: 'ENG', restaurantId: locationId } })
            .then((r) => r.data).catch(report('deal-dishes'));
        const groups: any[] = Array.isArray(data?.allItems) ? data.allItems : [];
        const dishes: MenuDish[] = [];
        groups.forEach((g) => (g?.menuItems ?? []).forEach((it: any) => {
            if (it?.id != null) dishes.push({ id: Number(it.id), name: String(it.itemName ?? it.name ?? it.id), price: String(it.price ?? '') });
        }));
        return dishes;
    }
}
